/**
 * SheetsApp_v2 Definition
 * App metadata for the unified Spreadsheet application
 */

import type { AppDefinition } from '../../types/apps';

export const SheetsAppV2Definition: AppDefinition = {
  appId: 'sheets-v2',
  name: 'Sheets',
  version: '2.0.0',
  description: 'Spreadsheet application with formulas and real-time collaboration.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Table',
    phosphorWeight: 'fill',
    color: '#10b981',
  },
  component: 'SheetsApp_v2',
  entityTypes: ['Sheet', 'Spreadsheet'],
  requiresProps: false,
  requiresEntity: true,
  isCore: true,
};

export const sheetsAppV2Definition = {
  id: 'sheets-v2',
  name: 'Sheets v2',
  description: 'Spreadsheet application with formulas and real-time collaboration',
  version: '2.0.0',
  
  // Entity types this app handles
  entityTypes: ['Sheet', 'Spreadsheet'],
  
  // Version requirement
  requiresVersion: 'v2',
  
  // Features
  features: {
    collaboration: true,
    aiCommands: true,
    formulas: true,
    gridQueries: true,
    export: true,
    offline: true,
  },
  
  // UI
  icon: '📊',
  color: '#4CAF50',
  
  // Commands
  supportsCommands: [
    'entity_read',
    'entity_write',
    'entity_export',
  ],
};

export default sheetsAppV2Definition;

